import { createBrowserRouter } from "react-router-dom";

import Upload from "./components/upload/upload";
import Dashboard from "./components/dashboard/dashboard";
import GoogleSignIn from "./auth/GoogleSignIn";
import Header from "./components/header/header";
import Login from "./components/login/login";
import Loginheader from "./components/header/loginheader";
import Chatpage from "./components/chatpage/chatpage";
import Coverage from "./components/chatpage/coverage";
import Generate_Parent from "./components/chatpage/generateparent";
import EditUpload from "./components/upload/editupload";
import ProtectedRoute from "./protectedroute";
import NotFound from "./components/notfound";
import Knowledgebase from "./components/knowledgebase/knowledgebase";
import Copilot from "./components/copilot/copilot";

import KbServiceDocsRedirect from "@/components/redirect/kb-service-docs-redirect";
import Layout from "@/components/layout/layout";
import FileComparison from "@/components/compare/file-comparison";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: [<Loginheader />, <Login />],
    },
    {
      path: "/login",
      element: [<Loginheader />, <Login />],
    },
    {
      path: "/",
      element: <ProtectedRoute />, // Wrap protected routes in ProtectedRoute
      children: [
        {
          path: "/",
          element: [<Loginheader />, <Login />],
        },
        {
          path: "/login",
          element: [<Loginheader />, <Login />],
        },
        {
          path: "/upload",
          element: [<Header />, <Upload />],
        },
        {
          path: "/dashboard",
          element: [<Header />, <Dashboard />],
        },
        {
          path: "/chatpage",
          element: [<Header />, <Chatpage />],
        },
        {
          path: "/generateparent",
          element: [<Header />, <Generate_Parent />],
        },
        {
          path: "/editupload",
          element: [<Header />, <EditUpload />],
        },
        {
          path: "/knowledgebase",
          element: [<Header gcsPath="gs://dxcm_user_guide/DexcomPhase 2 __ User Guide for Knowledge Base.pdf" />, <Knowledgebase />],
        },
        {
          path: "/copilot",
          element: [
            <Layout>
              <Copilot />
            </Layout>,
          ],
        },
        {
          path: "/file-comparison",
          element: [
            <Layout>
              <FileComparison />
            </Layout>,
          ],
        },
        {
          path: "/docs/kb-service",
          element: <KbServiceDocsRedirect />,
        },
      ],
    },
    {
      path: "*", // Catch-all route for 404
      element: <NotFound />,
    },
  ],
  {
    future: {
      v7_startTransition: true,
    },
  }
);
